/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import env from 'env'
import { getURLSearchParams } from 'redux-app/utils/api'
import { getCardTypeByNumber } from 'utils/payment'
import { VALUE_KEYS } from './constants'

interface IValues {
  [VALUE_KEYS.merchantGuid]: string,
  [VALUE_KEYS.accessToken]: string,
  [VALUE_KEYS.paymentCreditCard]: string,
  [VALUE_KEYS.expMonth]: number,
  [VALUE_KEYS.expYear]: number,
  [VALUE_KEYS.CVV]: number,
}

interface IResult {
  code: number,
  success: boolean,
}

class Paymetric {
  private static firstToUp = (str: string): string => str.charAt(0).toUpperCase() + str.substr(1)

  private static prepareRequestData = ({ accessToken, merchantGuid, ...restValues }: IValues) =>
  {
    var data = $XIPlugin.createJSRequestPacket(merchantGuid, accessToken);

    Object.entries({
      ...restValues,
      [VALUE_KEYS.type]: getCardTypeByNumber(_get(restValues, VALUE_KEYS.paymentCreditCard)),
    }).forEach(([key, value]) => {
      var myField = $XIPlugin.createField(Paymetric.firstToUp(key), key === VALUE_KEYS.paymentCreditCard, value);
      data.addField(myField);
    })

    return data;
  }

  private readonly url = `${env.paymetric}/diecomm/Ajax`
  private readonly headers = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
    'x-requested-with': 'XMLHttpRequest',
  }

  public submit = async (data: IValues): Promise<IResult> => {

    var ccData = Paymetric.prepareRequestData(data)

    return new Promise((resolve, reject) => {

      $XIPlugin.ajax({
        url: this.url,
        type: "POST",
        data: ccData,
        success: function(result) {
  
           if (result.UrlsAndPayloadsFor3Ds) {
            const url = result.UrlsAndPayloadsFor3Ds.CentinelAcsUrl
            const formData = getURLSearchParams({
              PaReq: result.UrlsAndPayloadsFor3Ds.CentinelPayload,
              TermUrl: result.UrlsAndPayloadsFor3Ds.CentinelTermUrl,
              MD: result.UrlsAndPayloadsFor3Ds.PaymetricPayload,
            })
  
            return fetch(url, {
              method: 'POST',
              headers: this.headers,
              body: formData,
            })
          }
          else {
            resolve({
              code: result.Code,
              success: result.HasPassed,
            });
          }
        },
        error: function(err) {
          reject({
            code: err.Code,
            success: err.HasPassed,
          });
        },
      })
    });
  }
}

export default Paymetric
